export function normalizarPrecoCatalogo(valor: unknown): number | null {
  if (typeof valor !== 'number' && typeof valor !== 'string') return null;
  const texto = String(valor).trim();
  if (!texto) return null;
  const numero = Number(texto.includes(',') ? texto.replace(/\./g, '').replace(',', '.') : texto);
  return Number.isFinite(numero) && numero >= 0 ? numero : null;
}

// O primeiro grupo já define o preço inicial no catálogo. Grupos posteriores
// podem conter guarnições gratuitas e não substituem esse preço.
export function precoCatalogoProduto(produto: any): { valor: number; aPartirDe: boolean } | null {
  const base = normalizarPrecoCatalogo(produto.valor);
  if (base === null) return null;
  if (base > 0) return { valor: base, aPartirDe: false };
  const itens = produto.grupoComplementos?.[0]?.itens;
  if (!Array.isArray(itens)) return null;
  const precos = itens.map((item: any) => normalizarPrecoCatalogo(item.price))
    .filter((valor: number | null): valor is number => valor !== null);
  return precos.length ? { valor: Math.min(...precos), aPartirDe: true } : null;
}
